import { useMirrorLoading } from '@goodlok/ui'
import { FunctionComponent, useMemo } from 'react'
import { useAdminPageData } from '../utilities/useAdminPageData'
import { AdminHead } from './AdminHead'
import styles from './AdminLayout.module.sass'
import { AdminTimetable } from './AdminTimetable'

export const AdminLayout: FunctionComponent = () => {
	const pageData = useAdminPageData()
	const isLoading = useMemo(
		() => pageData.isLoading || pageData.isInitialLoading,
		[pageData.isLoading, pageData.isInitialLoading]
	)
	useMirrorLoading(isLoading)

	return (
		<div className={styles.wrapper}>
			{pageData.data && (
				<>
					<AdminHead />
					<AdminTimetable
						venue={pageData.data?.getVenue}
						updateData={async () => {
							await pageData.refetch()
						}}
						isLoading={isLoading}
					/>
				</>
			)}
		</div>
	)
}
